import {
  FETCHING_ORG,
  FETCH_ORG_SUCCESS,
  FETCHING_PERMISSIONS,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE
} from './ManageUserConstants';
import { LOGOUT_SUCCESS } from 'redux/auth/AuthConstants';

const USER_PERMISSIONS = 'userPermissions';
const userPermissions = sessionStorage.getItem(USER_PERMISSIONS);

const initialStore = {
  isFetchingOrg: false,
  selectedOrg: {},
  contextTree: [],
  isFetchingPermissions: false,
  userPermissions: userPermissions ? JSON.parse(userPermissions) : [],
  fetchingSolutionConfigurations: false,
  solutionConfigurations: {
    noPrintServices: false
  }
};

const selectRootOrg = orgs => {
  let rootOrg = orgs[0];
  orgs.forEach(currentOrg => {
    if (currentOrg.parentId == null) {
      rootOrg = currentOrg;
    }
  });
  return rootOrg;
};

const ManageUserReducer = (state = initialStore, action) => {
  switch (action.type) {
    case FETCHING_ORG:
      return { ...state, isFetchingOrg: true };

    case FETCH_ORG_SUCCESS:
      return { ...state, isFetchingOrg: false, selectedOrg: selectRootOrg(action.data) };

    case FETCHING_PERMISSIONS:
      return { ...state, isFetchingPermissions: true };

    case FETCH_PERMISSIONS_SUCCESS: {
      sessionStorage.setItem(USER_PERMISSIONS, JSON.stringify(action.data.items));
      return {
        ...state,
        isFetchingPermissions: false,
        userPermissions: [ ...action.data.items ]
      };
    }

    case FETCH_PERMISSIONS_FAILURE:
      return { ...state, isFetchingPermissions: false };

    case LOGOUT_SUCCESS: {
      sessionStorage.removeItem(USER_PERMISSIONS);
      return { ...initialStore };
    }

    default:
      return { ...state };
  }
};

export default ManageUserReducer;



// WEBPACK FOOTER //
// ./src/redux/manageUser/ManageUserReducer.js